module.exports = {
          srcSet: __webpack_public_path__ + "72490d12783eaddee774246566986df2-374.png"+" 374w",
          images:[ {path: __webpack_public_path__ + "72490d12783eaddee774246566986df2-374.png",width: 374,height: 280}],
          src: __webpack_public_path__ + "72490d12783eaddee774246566986df2-374.png",
          toString:function(){return __webpack_public_path__ + "72490d12783eaddee774246566986df2-374.png"},
          
          width: 374,
          height: 280
        }